import Constants from '../../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}depionier/`;

const title = "Holy Road - De Pionier";
const description = "De Joodse buitenpost Amona was gebouwd op het land van Palestijnse boeren. De Palestijnen stapten naar de rechter, en wonnen. Met dank aan een Joodse Israëliër.";
const featuredImage = `${imageFolder}depionier/omslag.jpg`;

export default [
    {
        type: "Meta",
        title: title,
        meta: [
            {"property": "og:title", "content": title},
            {"property": "og:url", "content": `${Constants.DOMAIN}${Constants.STORY_URL}depionier`},
            {"property": "description", "content": ""},
            {"property": "og:description", "content": description},
            {"property": "og:image", "content": featuredImage},
            {"property": "twitter:card", "content": `summary_large_image`},
            {"property": "twitter:title", "content": title},
            {"property": "twitter:description", "content": description},
            {"property": "twitter:image", "content": featuredImage},
        ]
    },
    {
        type: "Quote",
        quote: description,
    },
    {
        type: "Iframe",
        hideSpacer: true,
        url: "https://player.vimeo.com/video/216161527"
    },
    {
        type: "Paragraph",
        text: "Eli Greenberg woonde op een heuvel op de Westelijke Jordaanoever. Goed, misschien was het land waarop zijn huis stond wettelijk in het bezit van een Palestijn, maar wie maalt daarom? Het belangrijkste is, vindt Greenberg, dat dit gebied drieduizend jaar geleden door God aan de Joden is beloofd. Geen wet die dat kan veranderen."
    },
    {
        type: "Paragraph",
        text: "Volgens het internationaal recht houdt Israël de Westelijke Jordaanoever bezet. Maar een groeiend aantal Joodse kolonisten trekt zich hier helemaal niks van aan. Zij luisteren niet naar de wetgever, maar alleen naar God. Een deel van hen keert om die reden zelfs de Israëlische staat de rug toe. Israël, vinden zij, zou een theocratie moeten worden, met de Thora als grondwet."
    },
    {
        type: "Paragraph",
        text: "De Palestijnen van de Westelijke Jordaanoever beschouwen zichzelf als de inheemse bewoners van dit land die bedreigd worden door uitheemse Joodse kolonisten die hun het leven zuur maken. Op hun beurt beweren de kolonisten: wij zijn de echte inheemsen, wij zaten hier duizenden jaren geleden al."
    },
    {
        type: "Paragraph",
        text: "Seculiere Israëliërs moeten niets hebben van hun fanatieke landgenoten. Toch moeten zij met lede ogen aanzien hoe de extremisten meer en meer invloed krijgen op het Israëlische regeringsbeleid. Wel hebben linkse activisten wat succesjes geboekt bij het Israëlische hooggerechtshof. Hierdoor raakte kolonist Greenberg bijvoorbeeld zijn land kwijt."
    },
    {
        type: "Paragraph",
        text: "De toekomst van de vredesbeweging ziet er donker uit. De hele Israëlische politiek schuift naar rechts op, en met hen ook hun electoraat. Het is gemeengoed geworden in Israël om te beweren dat 'alle Arabieren terroristen' zijn, of dat ze worden geboren om Joden te haten. De vredesactivisten worden zélf flink gedemoniseerd in de Israëlische samenleving."
    }
]


// WEBPACK FOOTER //
// ./src/data/nl/stories/story6.js